var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dataViewPage",
      staticClass: "ds-control ds-page data-view-page",
      class: _vm.getCss,
      style: _vm.$pageStyle,
      attrs: { "page-type": _vm.pageType },
    },
    [
      _vm.hasDataViewHead
        ? _c("div", { staticClass: "ds-page-head" }, [
            _c(
              "div",
              {
                ref: "head",
                staticClass: "head-inner",
                attrs: { "slot-name": _vm.slots[1].name },
              },
              [_vm._t(_vm.slots[1].name)],
              2
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "ds-page-content" }, [
        _c(
          "div",
          {
            staticClass: "data-view-page-wrap dsf-drag-view ds-no-padding",
            attrs: { "slot-name": _vm.slots[0].name },
          },
          [
            _vm.isDesign
              ? _c(
                  "div",
                  { staticClass: "dsf-drag-view-tools" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "dsf-drag-view-tools-item dsf-drag-view-tools-item-toggles",
                      },
                      [
                        _c("DsfIcon", {
                          class:
                            _vm.isShowTools &&
                            "dsf-drag-view-tools-item-toggles-icon-active",
                          attrs: { name: "tuding" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.isShowTools = !_vm.isShowTools
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.isShowTools
                      ? _vm._l(_vm.layoutButs, function (item) {
                          return _c(
                            "div",
                            {
                              key: item,
                              staticClass: "dsf-drag-view-tools-item",
                              class: { "active-btn": _vm.active === item },
                              on: {
                                click: function ($event) {
                                  return _vm.handleChangeActiveScreen(item)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item) + " ")]
                          )
                        })
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              {
                ref: "box",
                staticClass: "dsf-layout-container",
                class: { "dsf-layout-container__design": _vm.isDesign },
              },
              [
                _vm.isPageLoaded
                  ? _vm._l(_vm.layout, function (item, index) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.handleShow(index),
                              expression: "handleShow(index)",
                            },
                          ],
                          key: index,
                          staticClass: "dsf-layout-grid",
                          style: {
                            "z-index": item.zIndex,
                            "pointer-events": item.penetrate ? "none" : "auto",
                          },
                        },
                        _vm._l(item.layout[_vm.active], function (it) {
                          return _c(
                            "div",
                            {
                              key: it.i,
                              staticClass: "dsf-layout-grid-item",
                              style: _vm.setGridItemStyle(it, item),
                              attrs: {
                                "slot-name": _vm.getSlotName(it, index),
                              },
                            },
                            [_vm._t(_vm.getSlotName(it, index))],
                            2
                          )
                        }),
                        0
                      )
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]),
      _c("div", {
        staticStyle: { display: "none" },
        domProps: { innerHTML: _vm._s(_vm.customCss) },
      }),
      _vm.designerSelectsLines.length > 1
        ? _c("SelectLines", {
            attrs: { originLines: _vm.designerSelectsLines },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }